import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  WritableSignal,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EventPaymentEnum } from 'src/app/models/event.model';
import { StripeError } from '@stripe/stripe-js';
import { EVENT_DAILY_COST } from 'src/app/helpers/eventCost';

@Component({
  selector: 'app-payment-type-step',
  templateUrl: './payment-type-step.component.html',
  styleUrls: ['../event-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentTypeStepComponent {
  eventForm: InputSignal<UntypedFormGroup> = input.required();
  isEventLocked: InputSignal<boolean> = input.required();
  eventCost: InputSignal<number> = input.required();
  eventUpcomingCharge: InputSignal<number> = input.required();
  isEventPaid: InputSignal<boolean> = input.required();
  stripeError: InputSignal<WritableSignal<StripeError | null>> =
    input.required();
  submitted: InputSignal<boolean> = input.required();

  EventPaymentEnum: typeof EventPaymentEnum = EventPaymentEnum;
  EVENT_DAILY_COST: typeof EVENT_DAILY_COST = EVENT_DAILY_COST;

  get paymentType() {
    return this.eventForm().get('paymentType');
  }
}
